/* eslint-disable no-unused-vars */
import axios from 'axios'

export default {
  create: (context, payload) => {
    const { commit } = context
    
    return new Promise((resolve, reject) => {
      axios.post('ticket', payload)
        .then(response => {
          const { data } = response

          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  edit: (context, payload) => {
    const { commit } = context
    const { id } = payload

    return new Promise((resolve, reject) => {
      axios.put(`ticket/${id}`, payload)
        .then(response => {
          const { data } = response

          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  list: (context, payload) => {
    const { commit } = context

    return new Promise((resolve, reject) => {
      axios.get('ticket', {
        params: payload,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          commit('setTickets', response.data)
          
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  find: (context, payload) => {
    const { commit } = context
    const { id } = payload

    return new Promise((resolve, reject) => {
      axios.get(`ticket/${id}`, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  publish: (context, payload) => {
    const { commit } = context
    const { id } = payload

    return new Promise((resolve, reject) => {
      axios.put(`ticket/${id}/publish`, payload)
        .then(response => {
          const { data } = response

          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  print: (context, payload) => {
    const { commit } = context
    const { id } = payload

    return new Promise((resolve, reject) => {
      axios.get(`ticket/${id}/print`, {
        responseType: 'blob',
      })
        .then(response => {
          const { data } = response

          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  close: (context, payload) => {
    const { commit } = context
    const { id } = payload

    return new Promise((resolve, reject) => {
      axios.put(`ticket/${id}/close`, payload)
        .then(response => {
          const { data } = response

          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  changeState: (context, payload) => {
    const { commit } = context
    const { id } = payload

    return new Promise((resolve, reject) => {
      axios.put(`ticket/${id}/state`, payload)
        .then(response => {
          const { data } = response

          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  upload: (_context, payload) => {
    //const { commit } = context
    const { id, attachments } = payload
    const uploads = attachments
      .filter(x => !x.id)
      .map(attachment => {
        const { formData } = attachment
        return new Promise((resolve, reject) => {
          axios.put(`ticket/${id}/attachment`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
            .then(response => {
              const { data } = response;
    
              resolve(data)
            })
            .catch(err => {
              reject(err)
            })
        })
      })

    return Promise.all(uploads)
  },
  deleteAttachment: (_context, payload) => {
    //const { commit } = context
    const { id, attachment } = payload

    return new Promise((resolve, reject) => {
      axios.delete(`ticket/${id}/attachment/${attachment}`, payload)
        .then(response => {
          const { data } = response

          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  listAudit: (context, payload) => {
    const { commit } = context
    const { id } = payload

    return new Promise((resolve, reject) => {
      axios.get(`ticket/${id}/audits`, {
        params: payload,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          const { data } = response

          commit('setAudits', data)
          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  exportExcel: (_context, _payload) => {
    return new Promise((resolve, reject) => {
      axios.get(`ticket/export`, {
        responseType: 'blob'
      })
        .then(response => {
          const blob = new Blob([response.data], {
            type: response.headers['content-type']
          })

          const link = document.createElement('a')
          const url = window.URL.createObjectURL(blob)
          link.href = url

          link.setAttribute('download', "Export.xlsx")
          document.body.appendChild(link)
          link.click()

          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
          
          resolve()
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}
